// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { RedundancySupport } from "./redundancy-support";

/**
 * Redundant-server failover configuration.
 */
export class RedundancyConfig implements flatbuffers.IUnpackableObject<RedundancyConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RedundancyConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRedundancyConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: RedundancyConfig,
  ): RedundancyConfig {
    return (obj || new RedundancyConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRedundancyConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: RedundancyConfig,
  ): RedundancyConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RedundancyConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  mode(): RedundancySupport {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : RedundancySupport.None_;
  }

  /**
   * How long to wait before failing over, in milliseconds.
   * NOTE: the failover endpoint URLs live on the Channel (alongside the
   * primary endpoint), not in the adapter template.
   */
  failoverTimeoutMs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 5000n;
  }

  static startRedundancyConfig(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMode(builder: flatbuffers.Builder, mode: RedundancySupport) {
    builder.addFieldInt8(0, mode, RedundancySupport.None_);
  }

  static addFailoverTimeoutMs(builder: flatbuffers.Builder, failoverTimeoutMs: bigint) {
    builder.addFieldInt64(1, failoverTimeoutMs, 5000n);
  }

  static endRedundancyConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRedundancyConfig(
    builder: flatbuffers.Builder,
    mode: RedundancySupport,
    failoverTimeoutMs: bigint,
  ): flatbuffers.Offset {
    RedundancyConfig.startRedundancyConfig(builder);
    RedundancyConfig.addMode(builder, mode);
    RedundancyConfig.addFailoverTimeoutMs(builder, failoverTimeoutMs);
    return RedundancyConfig.endRedundancyConfig(builder);
  }

  unpack(): RedundancyConfigT {
    return new RedundancyConfigT(this.mode(), this.failoverTimeoutMs());
  }

  unpackTo(_o: RedundancyConfigT): void {
    _o.mode = this.mode();
    _o.failoverTimeoutMs = this.failoverTimeoutMs();
  }

  unpackFields(...fields: string[]): RedundancyConfigT {
    const t = new RedundancyConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("failover_timeout_ms")) {
      t.failoverTimeoutMs = this.failoverTimeoutMs();
    }
    return t;
  }
}

export class RedundancyConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public mode: RedundancySupport = RedundancySupport.None_,
    public failoverTimeoutMs: bigint = 5000n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return RedundancyConfig.createRedundancyConfig(builder, this.mode, this.failoverTimeoutMs);
  }

  clone(): RedundancyConfigT {
    const obj = new RedundancyConfigT();
    obj.mode = this.mode;
    obj.failoverTimeoutMs = this.failoverTimeoutMs;
    return obj;
  }

  equals(other: RedundancyConfigT): boolean {
    if (this.mode !== other.mode) return false;
    if (this.failoverTimeoutMs !== other.failoverTimeoutMs) return false;
    return true;
  }
}

export function verifyRedundancyConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 8);
  } finally {
    verifier.popDepth();
  }
}
